import type { ScreenModule } from "../../../app/screen-module";
import { AllUsersPage } from "../pages";

export default {
	id: "system-admin.users",
	path: "/system/users",
	area: "system-admin",
	navGroup: "製品",
	label: "ユーザー",
	roles: ["platform_admin", "platform_viewer"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: AllUsersPage,
} satisfies ScreenModule;
